// This file is generated.
export var version = '1.36.5';